import { CallStackResolution } from "../Causation/CallStackResolution";

export type ScreenRecordingDisplaySurface = "browser" | "window" | "monitor";
export const ScreenRecordingDisplaySurfaces = {
	Tab: "browser",
	Window: "window",
	Screen: "monitor",
} as const satisfies Record<string, ScreenRecordingDisplaySurface>;

export const ObservationPanelPlacement = [
	'side-panel',
	'new-tab',
	'new-window',
	'none',
] as const;
export type ObservationPanelPlacement = NonNullable<typeof ObservationPanelPlacement[number]>;
export const ObservationPanelPlacementOptionLabels = [
	['side-panel', 'in the side of the tab'],
	['new-window', 'in a new window'],
	['new-tab', 'in a new tab'],
	['none', 'later (via DevTools)'],
] as const satisfies [ObservationPanelPlacement, string][];

export interface MainWorldRecordingSettings {
	// proxyDomMessageEventsToDetectDataRead: boolean;
	// proxyDomEventsToDetectPropertiesRead: boolean;
}

export interface EvidenceRecordingSettings extends MainWorldRecordingSettings {
	startNetworkRecordingWhenDebugPanelOpens: boolean;
	startVideoRecordingExtensionStartsRecordingNetwork: boolean;
	searchInRealTime: boolean;
	whereToOpenObservationPanelOnNewRecording: ObservationPanelPlacement;
	preferredScreenRecordingDisplaySurface: ScreenRecordingDisplaySurface;
	recordGeolocationEvents: boolean;
	setGeolocationTo: { latitude: number, longitude: number, accuracy?: number } | undefined;
	monitorInboundNetworkTraffic: boolean;
	injectContentScripts?: boolean;
	archiveDirectoryHandle: FileSystemDirectoryHandle | undefined;
	callStackResolution?: CallStackResolution;
	crawlTargetsFileHandle?: FileSystemFileHandle;
	crawlOutputDirectoryHandle?: FileSystemDirectoryHandle;
	activeClientName?: string;
}

export interface ExtensionSettings extends EvidenceRecordingSettings {
	sharedSearchTerms?: string;
}

export const defaultSettings: ExtensionSettings = {
	startNetworkRecordingWhenDebugPanelOpens: false,
	startVideoRecordingExtensionStartsRecordingNetwork: true,
	searchInRealTime: true,
	whereToOpenObservationPanelOnNewRecording: 'side-panel',
	preferredScreenRecordingDisplaySurface: ScreenRecordingDisplaySurfaces.Window,
	// proxyDomMessageEventsToDetectDataRead: true,
	// proxyDomEventsToDetectPropertiesRead: true,
	recordGeolocationEvents: true,
	setGeolocationTo: { latitude: 86.753099035768, longitude: -86.753099035768 },
	monitorInboundNetworkTraffic: true,
	archiveDirectoryHandle: undefined,
	injectContentScripts: true,
}

export type ExtensionSettingsPartial = Partial<ExtensionSettings>;

export type ExtensionSettingsUpdate = {
	[k in keyof ExtensionSettingsPartial]: ExtensionSettingsPartial[k] | undefined;
};